class slickHelper {
    constructor() {
        console.log('Slick helper initialized');
    }
    bindSlickCarousel(el) {
        console.log('Slick bound to el:', el);
        window.$(el).slick({
            dots: true,
            appendDots: $(el).parent(),
            arrows: true,
            infinite: true,
            speed: 1000,
            slidesToShow: 2,
            slidesToScroll: 2,
            adaptiveHeight: false,
            autoplay: true,
            autoplaySpeed: 5000,
            prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><img src="/assets/img/slick_left.svg" alt=""></button>',
            nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><img src="/assets/img/slick_right.svg" alt=""></button>',
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }]
        });
    }
    bindSlickCarouselvariant2(el) {
        console.log('Slick bound to el:', el);
        window.$(el).slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 1000,
            slidesToShow: 3,
            slidesToScroll: 1,
            adaptiveHeight: false,
            autoplay: true,
            autoplaySpeed: 5000,
            prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><img src="/assets/img/slick_left.svg" alt=""></button>',
            nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><img src="/assets/img/slick_right.svg" alt=""></button>',
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 5000
                }
            }]
        });
    }
}
window.app.add('slick', new slickHelper());


// WEBPACK FOOTER //
// ./wp-content/themes/usdigitalpartners/modules/image-slider-module/includes/image-slider-module.js